import React, { useContext, useEffect } from "react";
import TimeTable from "./TimeTable";
import { RouteComponentProps } from "react-router-dom";
import { Modify } from "utils/types";
import { ReservationContext } from "Contexts/ReservationContext";
import { AuthContext } from "Contexts/AuthContext";
import useAlert from "CustomHooks/useAlert";

export type TimeTableContainerProps = Modify<
  RouteComponentProps,
  {
    match: { params: { date: string; restaurantId: string } };
  }
>;

const TimeTableContainer: React.FC<TimeTableContainerProps> = ({
  history,
  match,
}) => {
  const { date, restaurantId } = match.params;

  const { setrestaurantId } = useContext(AuthContext);
  const { setdate, TablePlanAssistant } = useContext(ReservationContext);
  const alert = useAlert();

  const goToDate = async (newDate: string) => {
    if (TablePlanAssistant.active) {
      await TablePlanAssistant.clearChanges();
      TablePlanAssistant.close();
    }

    history.push(`/${restaurantId}/reservations/${newDate}/timeTable`);
  };

  const onDateChange = (newDate: string) => {
    if (newDate === date) return;

    if (TablePlanAssistant.changes.length) {
      alert({
        title: "Entwurfsänderungen verwerfen?",
        description:
          "Wenn du den Tag wechselst, werden alle Änderungen des Reservierungs-Assistenten entfernt.",
        severity: "warning",
        submitLabel: "Tag wechseln",
        onSubmit: () => {
          goToDate(newDate);
        },
      });
      return;
    }

    goToDate(newDate);
  };

  useEffect(() => {
    setdate(match.params.date);
    setrestaurantId(restaurantId);
  }, [match.params]);

  return <TimeTable {...{ date, restaurantId, onDateChange }} />;
};

export default TimeTableContainer;
